import React, {Component} from 'react'
import PropTypes from "prop-types";
import PatientSelectComponent from "../../../components/single_components/PatientSelectComponent";
import Error from "../../../components/single_components/Error";
import SvGraphics from "../../../assets/SvGraphics";

class SelfUseOfCannabisTab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checkboxes: this.props.checkboxes,
            addedProducts: this.props.addedProducts,
            entry: this.props.entry,
            Smoked_cannabis: false,
            otherDiseaseReason: false,
            otherTypeUsed: false,
            hasLicense: false,
            Smoked_medical_cannabis: false,
            Smoked_recreational_cannabis: false,
            productsList:this.props.productsList,
            patient_products:[]
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
        if (this.props.checkboxes !== prevProps.checkboxes) {
            this.setState({
                checkboxes: this.props.checkboxes
            })
        }
    }

    componentDidMount() {
        let {entry,checkboxes} = this.state
        let smoked = this.state.entry.Smoked_cannabis === "YesPast" || entry.Smoked_cannabis === "YesPresent"
        this.setState({
            Smoked_cannabis: smoked,
            hasLicense: checkboxes.Have_license_israel,
            Smoked_recreational_cannabis: entry.Smoked_cannabis_cause === "Recreational",
            Smoked_medical_cannabis: entry.Smoked_cannabis_cause === "Medical",
            otherTypeUsed: entry.OtherTypeUsed === "Yes",
            otherDiseaseReason: this.state.checkboxes.OtherDiseaseReason
        })
    }

    onclickSmoked_cannabis(event) {
        let {entry} =this.state
        if ((event.target.value === "YesPast" && entry.Smoked_cannabis_cause==="Medical")||event.target.value === "No"){
            this.props.onClickAddProducts("Delete","","")
            this.setState({addedProducts: this.props.addedProducts})
        }


        if (event.target.value === "YesPast" || event.target.value === "YesPresent")
        {this.setState({Smoked_cannabis: true})
        } else {
            this.setState({Smoked_cannabis: false,
                Smoked_recreational_cannabis: false,
                hasLicense: false,
                Smoked_medical_cannabis: false,

            })
            this.props.onValueChange("Smoked_cannabis_cause", "")
            this.props.onValueChange("Smoked_medical_cannabis", "")
        }
        this.props.onValueChange("Smoked_cannabis", event.target.value)
    }

    onclickSmoked_medical_cannabis(event) {
        let {entry}=this.state

        let medicalBool= event.target.value === "Medical"
        let recreationalBool=event.target.value === "Recreational"

        if ((entry.Smoked_cannabis === "YesPast" && event.target.value==="Medical")||entry.Smoked_cannabis === "No"){
            this.props.onClickAddProducts("Delete"," "," ")
            this.setState({
                addedProducts: this.props.addedProducts,
                Smoked_medical_cannabis: medicalBool,
                Smoked_recreational_cannabis: recreationalBool,
            })
        }else{
            this.setState({
                Smoked_medical_cannabis: medicalBool,
                Smoked_recreational_cannabis: recreationalBool,
            })
        }

        this.props.onValueChange("Smoked_cannabis_cause", event.target.value)
    }


    onclickOtherDiseaseReason(event) {
        this.setState({otherDiseaseReason: !this.state.otherDiseaseReason})
        this.props.onClickCheckboxes(event)
    }

    onclickOtherTypeUsed(event) {
        this.setState({otherTypeUsed: !this.state.otherTypeUsed})
        this.props.onClickCheckboxes("OtherDiseaseReason")

    }

    handleProductsChange(index,event){
        this.addPatientProduct("product_use_obj", event, index)
    }

    addPatientProduct(func,value,index){
        this.props.onClickAddProducts(func,value,index)
    }

    render() {
        let {t} = this.props

        let {checkboxes, entry,Smoked_medical_cannabis,Smoked_recreational_cannabis,Smoked_cannabis,productsList,addedProducts} = this.state
        let reasonOption = [
            t('patient_self_boarding.Pain'),
            t('patient_self_boarding.Palliative'), t('patient_self_boarding.Cancer'),
            t('patient_self_boarding.Neurologic_disease'), t('patient_self_boarding.Psychiatric_condition'),
            t('patient_self_boarding.Gastrointestinal_disease'), t('patient_self_boarding.Infectious_disease'),
            t('patient_self_boarding.Rheumatologic_disease'),
            t('patient_self_boarding.Unknown'), t('patient_self_boarding.other')]

        let category=[
            "T3/C15","T5/C10",
            "T10/C2","T10/C10","T15/C3",
             "T5/C5","Other"]
        let categoryOptions=[]
        categoryOptions = category.map(item =>
            <option className={'option-style'} value={item}>{item}</option>)

        let {patient_products}= this.state
        patient_products = addedProducts?addedProducts.map((item,index) =>
            <div className={'patientsFormRow'}
                 style={{display: Smoked_medical_cannabis||Smoked_recreational_cannabis ? 'block' : 'none'}}>
                <div className={'inputSlotsBlock'}>
                    <div style={{display:'flex',marginTop:'20px',width: '100%'}}>
                        <label style={{display: Smoked_medical_cannabis ? 'block' : 'none'}} className={'boxMargin-label'}> {t('patient_self_boarding.type')} </label>
                        <select style={{display: Smoked_medical_cannabis ? 'block' : 'none'}} className={'selectBox'} id="recreational_product_type"
                                name="product_type" value={item.product_type}
                                onChange={(event) => this.addPatientProduct("product_type", event.target.value,index)}>
                            <option/>
                            <option value={"Oil"}>{t('patient_self_boarding.Oil')}</option>
                            <option value={"Flower"}>{t('patient_self_boarding.Flower')}</option>
                        </select>
                        <label className={'boxMargin-label'}> {t('patient_self_boarding.Category')} </label>
                        <select className={'selectBox'} id="product_use_category"
                                name="product_use_category" value={item.product_use_category}
                                onChange={(event) => this.addPatientProduct("product_use_category", event.target.value,index)}
                            /*onChange={(event) => this.onclickChoosedCategory(event.target.value)}*/>
                            <option/>
                            {categoryOptions}
                        </select>
                        <label className={'boxMargin-label'}> {t('patient_self_boarding.product')} </label>
                        {/*   <select style={{display:item.product_use_category!=="Other"?'block':'none'}} className={'selectBox'} id="product_use"
                                name="product_use" value={item.product_use}
                                onChange={(event) => this.addPatientProduct("product_use", event.target.value,index)}>
                            <option/>
                            {item.displayProducts}
                        </select>*/}


                        {/*      <PatientSelectComponent
                            placeholder=""
                            autosize={true}
                            options={item.displayProducts}
                            value={item.product_use_obj}
                            onChange={this.handleProductsChange.bind(this,index)}
                        />
*/}
                        <PatientSelectComponent
                            name={'Product'}
                            options={item.displayProducts}
                            className={'multipleSelectBox'}
                            value={item.product_use_obj}
                            onChange={
                                this.handleProductsChange.bind(this,index)
                            }
                        />

                        <input style={{display:item.product_use_category==="Other"?'block':'none'}}
                               className={'inputBoxStyle'} type="other_product_use" name="product_use"
                               defaultValue={item.product_use}
                               onChange={(event) => this.addPatientProduct("product_use", event.target.value , index)}/>
                    </div>
                </div>
            </div>
        ):""

        let reasonOptions = []
        reasonOptions = reasonOption.map((item,index) =>
            <option className={'option-style'} value={index}>{item}</option>)

        return (
            <div  className={'patientForm-box-container'}>
                <div className={'patientsFormBoxes-title-text'}>
                    <label className={'patientsFormBoxes-title-text-label'}> {t('patient_self_boarding.CannabisUse')}</label>
                </div>
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabelCannabisPage'}>{t('patient_self_boarding.Smoked_cannabis')}?* </label>
                        <Error isShown={!!(this.props.errors)['Smoked_cannabis']} errorMessage={(this.props.errors)['Smoked_cannabis']}/>
                        <select className={'selectBox'} id="Smoked_cannabis" name="Smoked_cannabis"
                                value={entry.Smoked_cannabis}
                                onChange={this.onclickSmoked_cannabis.bind(this)}>
                            <option/>
                            <option value="No">{t('patient_self_boarding.no')}</option>
                            <option value="YesPast">{t('patient_self_boarding.YesPast')}</option>
                            <option value="YesSometimes">{t('patient_self_boarding.YesSometimes')}</option>
                            <option value="YesPresent">{t('patient_self_boarding.YesPresent')}</option>
                        </select>
                    </div>
                    <div className={'inputSlots'} style={{display: Smoked_cannabis ? 'block' : 'none'}}>
                        <label className={'infoLabelCannabisPage'}>{t('patient_self_boarding.Smoked_cannabis_cause')} </label>
                        <select className={'selectBox'} id="Smoked_cannabis_cause" name="Smoked_cannabis_cause"
                                value={entry.Smoked_cannabis_cause}
                                onChange={this.onclickSmoked_medical_cannabis.bind(this)}>
                            <option/>
                            <option value="Recreational">{t('patient_self_boarding.Recreational')}</option>
                            <option value="Medical">{t('patient_self_boarding.Medical')}</option>
                        </select>
                    </div>

                    <div className={'inputSlots'} style={{display: Smoked_medical_cannabis ? 'block' : 'none'}}>
                        <label className={'infoLabelCannabisPage'}>{t('patient_self_boarding.Consuming_license')}?</label>
                        <select className={'selectBox'} id="Consuming_license" name="Consuming_license"
                                value={entry.Consuming_license}
                                onChange={(event) => this.props.onValueChange("Consuming_license", event.target.value)}>
                            <option/>
                            <option value="6M">{t('patient_self_boarding.6M')}</option>
                            <option value="6M_1Y">{t('patient_self_boarding.6M_1Y')}</option>
                            <option value="1_3Y">{t('patient_self_boarding.1_3Y')}</option>
                            <option value="3_5Y">{t('patient_self_boarding.3_5Y')}</option>
                            <option value="5+Y">{t('patient_self_boarding.5+Y')}</option>
                        </select>
                    </div>
                </div>

                <div className={'patientsFormRow'} style={{display: Smoked_medical_cannabis||Smoked_recreational_cannabis ? 'block' : 'none'}}>
                    <div className={'inputSlotsBlock'}>
                        <div style={{display:"flex"}}>
                            <label className={'infoLabelCannabisPage'}>{t('patient_self_boarding.Cannabis_freq_past_year')} ({t('patient_self_boarding.gr_month')})</label>
                            <Error isShown={!!(this.props.errors)['Cannabis_freq_past_year']} errorMessage={(this.props.errors)['Cannabis_freq_past_year']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="Cannabis_freq_past_year" name="Cannabis_freq_past_year"
                               defaultValue={entry.Cannabis_freq_past_year}
                               maxLength={3} min={0} max={200}
                               onChange={(event) => this.props.onValueChange("Cannabis_freq_past_year", event.target.value)}/>
                    </div>
                </div>

                <div className={'patientsFormRow'} style={{display: Smoked_medical_cannabis ? 'flex' : 'none'}}>
                    <div className={'inputSlotsBlock'}>
                        <label className={'infoLabelCannabisPage'}>{t('patient_self_boarding.main_reason_for_using_medical_cannabis')}</label>
                        <select className={'selectBox'} id="main_reason_for_using_medical_cannabis"
                                name="main_reason_for_using_medical_cannabis"
                                value={entry.main_reason_for_using_medical_cannabis}
                                onChange={(event) => this.props.onValueChange("main_reason_for_using_medical_cannabis", event.target.value)}>
                            <option/>
                            {reasonOptions}
                        </select>
                    </div>
                    <div className={'inputSlots'}
                         style={{display: entry.main_reason_for_using_medical_cannabis === "Other" ? 'block' : 'none'}}>
                        <label className={'infoLabelCannabisPage'}>{t('patient_self_boarding.enter_main_reason')}</label>
                        <input  className={'inputBoxStyle'} type="text" name="OtherDiseaseReason" defaultValue={entry.OtherDiseaseReasonInput}
                                onChange={(event) => this.props.onValueChange("Other_main_reason_for_using_medical_cannabis", event.target.value)}/>
                    </div>
                </div>

                <div className={'patientsFormRow'} >
                    <div className={'inputSlotsFlex'} style={{ display: Smoked_medical_cannabis && entry.Smoked_cannabis!=="YesPast" ?'flex': 'none' }}>
                        <label className={'infoLabelCannabisPage'}>{t('patient_self_boarding.Have_license_israel')}?*</label>
                        <Error isShown={!!(this.props.errors)['Have_license_israel']} errorMessage={(this.props.errors)['Have_license_israel']}/>
                        <button tabIndex={0}  className={entry.Have_license_israel==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Have_license_israel","Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Have_license_israel==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Have_license_israel","No")}>{t('patient_self_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>


                <div className={'patientsFormRow'}
                     style={{display: !(checkboxes.Have_license_israel) && (Smoked_medical_cannabis||Smoked_recreational_cannabis)? 'block' : 'none'}}>
                    <label className={'infoLabelCannabisPage'}>{t('patient_self_boarding.method_used')}</label>
                    <div className={'checkboxes-Row'}>
                        <div className={'checkbox-label'}>
                            <input type={"checkbox"} className={"checkboxStyle2"} name="U_Flower"
                                   checked={entry.U_Flower}
                                   onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                            <label className={'infoLabel-checkbox'}>{t('patient_self_boarding.Flower')}</label>
                        </div>
                        <div className={'checkbox-label'}>
                            <input type={"checkbox"} className={"checkboxStyle2"} name="U_Flower_vaping"
                                   checked={entry.U_Flower_vaping}
                                   onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                            <label className={'infoLabel-checkbox'}>{t('patient_self_boarding.Flower_vaping')}</label>
                        </div>
                        <div className={'checkbox-label'}>
                            <input type={"checkbox"} className={"checkboxStyle2"} name="U_oil"
                                   checked={entry.U_oil}
                                   onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                            <label className={'infoLabel-checkbox'}>{t('patient_self_boarding.Oil')}</label>
                        </div>
                        {/*<div className={'checkbox-label'}>
                            <input type={"checkbox"} className={"checkboxStyle2"} name="U_oil_vaping"
                                   checked={entry.U_oil_vaping}
                                   onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                            <label className={'infoLabel-checkbox'}>{t('patient_self_boarding.Oil_vaping')}</label>
                        </div>
                        <div className={'checkbox-label'}>
                            <input type={"checkbox"} className={"checkboxStyle2"} name="U_edibles"
                                   checked={entry.U_edibles}
                                   onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                            <label className={'infoLabel-checkbox'}>{t('patient_self_boarding.Edibles')}</label>
                        </div>*/}
                        <div className={'checkbox-label'}>
                            <input type={"checkbox"} className={"checkboxStyle2"} name="U_accurate_dose_tool"
                                   checked={entry.U_accurate_dose_tool}
                                   onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                            <label className={'infoLabel-checkbox'}>{t('patient_self_boarding.Accurate_dose')}</label>
                        </div>
                       {/* <div className={'checkbox-label'}>
                            <input type={"checkbox"} className={"checkboxStyle2"} name="U_other" checked={entry.U_other}
                                   onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                            <label className={'infoLabel-checkbox'}>{t('patient_self_boarding.other')}</label>
                        </div>

                        <div className={'checkbox-label'} style={{display: entry.U_other ? 'block' : 'none'}}>
                            <input className={'inputBoxStyle'}  type="text" name="country" defaultValue={entry.U_other_text}
                                   onChange={(event) => this.props.onValueChange("U_other_text", event.target.value)}/>
                        </div>*/}
                    </div>
                </div>


                <div className={'patientsFormRow'}
                     style={{display: (Smoked_medical_cannabis && entry.Smoked_cannabis!=="YesPast")||Smoked_recreational_cannabis ? 'flex' : 'none'}}>
                    {/*
                    <div className={'inputSlots'}>
*/}
                    <label className={'infoLabelCannabisPage'} style={{marginTop:'10px'}}>{t('patient_self_boarding.recreational_product_use')}</label>
                    {/*
                    </div>
*/}


                </div>

                {(Smoked_recreational_cannabis ||  Smoked_medical_cannabis) && <div className={'svg-label-cannabis-use'}>
                    <SvGraphics className={"delete-icon"} svgname={'add-icon'}
                                onClick={() => this.addPatientProduct("ADD", "", 0)}/>
                    <div className={'addTarget'}
                         onClick={() => this.addPatientProduct("ADD", "", 0)}>{t('patient_self_boarding.add_product')}</div>
                </div>}
                {patient_products}


            </div>
            </div>

        )
    }
}

SelfUseOfCannabisTab.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    onClickCheckboxes:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    checkboxes: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default SelfUseOfCannabisTab;
